import React from 'react';
import { CgFilterSelect, CgFilterMultiSelect } from 'modules/Common/ui/CgFilterDropdown';
import { inputCls, labelClass } from 'modules/Common/form/v2/primitives/inputClasses';

/**
 * Inline filter row for the public share page's Products table.
 *
 * Mirrors the visual language of the v2 form fields (CgFilterSelect /
 * CgFilterMultiSelect for dropdowns, the shared inputCls for the text input)
 * so this row sits naturally above the table.
 */
export default function ShareCatalogFilters({
  values,
  onChange,
  yearOptions,
  cnCodeOptions,
  installationOptions,
}) {
  const set = (key, value) => onChange({ ...values, [key]: value });

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 mb-3">
      <div>
        <label className={labelClass}>Year</label>
        <CgFilterSelect
          options={yearOptions}
          value={values.year || ''}
          onChange={(v) => set('year', v || '')}
          placeholder="All years"
          isClearable
        />
      </div>

      <div>
        <label className={labelClass}>CN Code</label>
        <CgFilterMultiSelect
          options={cnCodeOptions}
          value={values.cnCode || []}
          onChange={(v) => set('cnCode', v || [])}
          placeholder="All CN codes"
          isClearable
          searchable
        />
      </div>

      <div>
        <label className={labelClass}>Installation</label>
        <CgFilterSelect
          options={installationOptions}
          value={values.installation || ''}
          onChange={(v) => set('installation', v || '')}
          placeholder="All installations"
          isClearable
          searchable
        />
      </div>

      <div>
        <label
          className={labelClass}
          htmlFor="share-product-id"
        >
          Product ID
        </label>
        <input
          id="share-product-id"
          type="text"
          value={values.productName || ''}
          onChange={(e) => set('productName', e.target.value)}
          placeholder="Search by product ID…"
          className={inputCls(false)}
        />
      </div>
    </div>
  );
}
